var newFlag = (function ($) {
    /* Public scope and variables */
    var self = {};

    /* Private functions */
    function init() {
        // Bootstrap the component
        bootstrap();
    }

    /**
     * Bootstrap the component
     */
    function bootstrap() {
        // Bind the events
        bindUI();
    }

    /**
     * Bind the html
     */
    function bindUI() {
        var newMenuItems = $('li.new');

        if (!newMenuItems)
            return false;

        add_new_flag(newMenuItems);

        return true;
    }

    function add_new_flag(newMenuItems) {
        if (!newMenuItems)
            return false;

        newMenuItems.each(function() {
            $(this).append("<a href='" + $(this).children().attr('href') + "' class='new-flag'>new</a>")
        });

        return true;
    }

    /* Public functions */
    self.stub = function () {

    }

    init();

    // Return the object itself.
    return self;

}(jQuery, window, {}));